import { UNADJUST_BILL_BANK_PAYMENT_REGISTER_REPORT_FAILURE, UNADJUST_BILL_BANK_PAYMENT_REGISTER_REPORT_REQUEST, UNADJUST_BILL_BANK_PAYMENT_REGISTER_REPORT_SUCCESS } from "../types";
  
  const initialState = {
    unadjustBillBankPaymentReport: {},
    loading: false,
    error: null,
  };
  
  const unadjustBillBankPaymentReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case UNADJUST_BILL_BANK_PAYMENT_REGISTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case UNADJUST_BILL_BANK_PAYMENT_REGISTER_REPORT_SUCCESS: {
        console.log("UNADJUST_BILL_BANK_PAYMENT_ Purchase Return Payload",action.payload);
        
        return {
          ...state,
          unadjustBillBankPaymentReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case UNADJUST_BILL_BANK_PAYMENT_REGISTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default unadjustBillBankPaymentReportReducer;
  